import { useState, useEffect, useCallback } from 'react'
import { useParams, useHistory } from 'react-router-dom'

export const getIds = (id, childId) => ({
  id: childId || id,
  parentId: childId ? id : undefined
})

export const save = async ({ id, childId, repository, data }) => {
  const ids = getIds(id, childId)
  id = ids.id
  return repository.update({ id: +id, ...data })
}

export default ({ repository, initialData = {} }) => {
  const { id, childId } = useParams()
  const history = useHistory()
  const [item, setItem] = useState(initialData)

  const getItem = useCallback(async () => {
    const response = await repository.getOne(getIds(id, childId))
    if (response.ok) {
      setItem(response.data)
    }
  }, [id, childId, repository])

  const onSubmit = async data => {
    const response = await save({
      data,
      repository,
      id,
      childId
    })
    if (response.ok) {
      setItem(response.data)
    }
    return response
  }

  useEffect(() => {
    getItem()
  }, [history.location.pathname, getItem])

  return {
    onSubmit,
    getItem,
    item
  }
}
